<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12 sm4 md6 lg6 class="align-self-center">
            <span class="heading">Snake List</span>
          </v-flex>
          <v-flex xs12 sm8 md6 lg6>
            <v-layout wrap align-center justify-end>
              <v-flex xs8 sm8 md8 lg8 pr-2>
                <v-text-field
                  outlined
                  hide-details clearable
                  dense
                  placeholder="Search By Name" class="text-des"
                  v-model="keyword"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 class="text-right">
                 <v-btn color="#427D2D" dark @click="openAddDialog()">
                    Add Snake
                 </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-if="items && items.length > 0">
            <v-layout wrap justify-start pt-2>
              <!-- <v-flex xs12 sm6 md6 lg6 class="subheading">
                    <span>Rows per page</span>
                    <v-select
                      v-model="count"
                      color="#427D2D"
                      outlined
                      dense
                      hide-details
                      :items="[20, 30, 50]"
                    ></v-select>
                  </v-flex> -->
              
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <!-- <v-simple-table> -->
                  <v-data-table
    :headers="computedHeaders"
    :items="items"
    hide-default-footer
    :items-per-page="-1"
    class="elevation-1 text--black"
    id="virtual-scroll-table"
    style="cursor: pointer;"
  >
    <template v-slot:[`item.name`]="{ item }">
      <span v-if="item && item.name">{{ item.name }}</span>
      <span style="color: grey;" v-else>-------</span>
    
</template>
    <template v-slot:[`item.scientificName`]="{ item }">
      <span v-if="item && item.scientificName">{{ item.scientificName }}</span>
      <span style="color: grey;" v-else>-------</span>
    </template>
    <template v-slot:[`item.family`]="{ item }">
      <span v-if="item && item.family">{{ item.family }}</span>
      <span style="color: grey;" v-else>-------</span>
    </template>
    <template v-if="mainRole === 'admin'" v-slot:[`item._id`]="{ item }">
      <v-icon small color="success" @click="openviewpage(item)">mdi-eye</v-icon>
      <v-icon small color="primary" class="ml-5" @click="openeditpage(item)">mdi-pencil</v-icon>
      <v-icon small color="red" class="ml-5" @click="opendeleteDialog(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else pt-16>
            <v-layout
              wrap
              justify-center
              align-center
             
            >
              <v-flex xs12 class="text-center">
                <span class="nodata">No Data Found !</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="items && items.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              circle
              color="#427D2D"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addSnakeDialog" max-width="900" scrollable transition="fade-transition">
      <v-card>
        <v-card-title class="heading">Add Snake Details
          <v-spacer></v-spacer>
          <v-btn icon @click="addSnakeDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-start>
            
          <v-flex xs12 pt-3>
            <span class="heading1">Basic Information</span>
          </v-flex>
          <v-flex xs12>
            <!-- BASIC INFO -->
            <v-layout wrap justify-start>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Common Name</span>
                <v-text-field outlined placeholder="eg : king cobra" v-model="commonname" dense hide-details>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-sm-2 pl-md-2 class="subheading">
                <span>Scientic Name</span>
                <v-text-field outlined placeholder="eg : Ophiophagus Hannah " v-model="scientificname" dense
                  hide-details>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Other Name</span>
                <v-text-field outlined v-model="othername" dense hide-details>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-sm-2 pl-md-2 class="subheading">
                <span>State</span>
                <v-select :items="statelist" outlined dense hide-details label="Select State" v-model="state">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Regional Name </span>
                <v-text-field outlined placeholder="eg : Naagraj (Hindi and Marathi); Rajavembala (Malayalam)"
                  v-model="reginonalname" dense hide-details>
                </v-text-field>
              </v-flex>
            </v-layout>
            <!-- OTHER INFO -->
            <v-layout wrap justify-start pt-4>
              <v-flex xs12>
                <span class="heading1">Other Information</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 class="subheading">
                <span>Geographic Presence</span>
                <vue-editor class="textField2 pt-1" v-model="distribution"></vue-editor>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Venom Type</span>
                <v-select :items="venom" outlined dense hide-details v-model="venomtype">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-sm-2 pl-md-2 class="subheading">
                <span>Family</span>
                <v-select :items="familylist" outlined dense hide-details v-model="family">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Genus</span>
                <v-select :items="genusitems" outlined dense hide-details v-model="genus">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-sm-2 pl-md-2 class="subheading">
                <span>Occurence</span>
                <v-select :items="occurenceitems" outlined dense hide-details v-model="occurence">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>WLPA</span>
                <v-select :items="WLPAitems" outlined dense hide-details v-model="wlpa">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-sm-2 pl-md-2 class="subheading">
                <span>IUCN</span>
                <v-select :items="IUCNitems" outlined dense hide-details v-model="iucn">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 class="subheading">
                <span>Scalation</span>
                <vue-editor class="textField2 pt-1" v-model="scalation"></vue-editor>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 class="subheading">
                <span>Description</span>
                <vue-editor class="textField2 pt-1" v-model="description"></vue-editor>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 class="subheading">
                <span>Short Description</span>
                <vue-editor class="textField2 pt-1" v-model="shortdescription"></vue-editor>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Assign to Expert</span>
                <v-select :items="expertlist" outlined dense hide-details v-model="experts" item-text="name"
                  item-value="_id">
                </v-select>
              </v-flex>
            </v-layout>
            <!-- Images -->
            <v-layout wrap justify-start pt-5>
              <v-flex xs12 class="heading1">
                <span>Add Snake Image</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-layout wrap justify-center pa-5 style="border: solid 1px #d6d6d6; border-radius: 4px;">
                  <v-flex xs12 text-left>
                    <v-chip
                      v-if="panCard.name"
                      class="ma-2"
                      outlined
                      color="#005f32"
                      text-color="#929292"
                    >
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left pa-2>
                          <span>{{ panCard.name }} </span>
                        </v-flex>
                      </v-layout>
                    </v-chip>
                    <v-flex xs12 text-right>
                      <v-btn
                        color="#848a84"
                        dark
                        small
                        @click="$refs.panCard.click()"
                        ><span
                          style="
                            font-size: 12px;
                            text-align: end;
                            letter-spacing: 0px;
                            opacity: 1;
                            color: white;
                          "
                        >
                          Choose Image
                        </span></v-btn
                      >
                    </v-flex>
                    <input
                      v-show="false"
                      id="file"
                      ref="panCard"
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      @change="panCardUpload($event)"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-3 pb-3>
              <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Caption</span>
                <v-text-field outlined v-model="caption" dense hide-details>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 class="subheading" pl-lg-2 pl-md-2 pl-sm-2>
                <span>Author</span>
                <v-text-field outlined v-model="author" dense hide-details>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" light :ripple="false" depressed @click="addSnakeDialog = false">
            Cancel
          </v-btn>
          <v-btn tile color="#427D2D" light :ripple="false" depressed @click="handlesubmit()">
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="deleteDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="deleteoperation()"
            class="itemValue"
          >
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rejectDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to reject?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="rejectDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="rejectoperation()"
            class="itemValue"
          >
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
            <script>
import axios from "axios";
export default {
  data() {
    return {
     
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      currentPage: 1,
      Pagelength: 0,
      userlist: [],
      items: [],
      status: "",
      deleteDialog: false,
      deleteid: "",
      rejectDialog: false,
      rejectid: "",

      addSnakeDialog: false,
      commonname: "",
      scientificname: "",
      othername: "",
      state: "",
      reginonalname: "",
      distribution: "",
      venomtype: "",
      family: "",
      genus: "",
      occurence: "",
      wlpa: "",
      iucn: "",
      scalation: "",
      description: "",
      shortdescription: "",
      expertlist: [],
      experts: "",
      familylist: [
        "Acrochordidae",
        "Colubridae",
        "Elapidae",
        "Erycidae",
        "Gerrhopilidae",
        "Homalopsidae",
        "Natricidae",
        "Pareidae",
        "Pythonidae",
        "Sibynophiidae",
        "Typhlopidae",
        "Uropeltidae",
        "Viperidae",
      ],
      venom: ["Highly Venomous", "Mildly Venomous", "Non Venomous"],
      genusitems: [
        "Acrochordus",
        "Ahaetulla",
        "Amphiesma",
        "Atretium",
        "Boiga",
        "Bungarus",
        "Calliophis",
        "Cerberus",
        "Chrysopelea",
        "Coelognathus",
        "Daboia",
        "Dendrelaphis",
        "Dieurostus",
        "Dryocalamus",
        "Echis",
        "Eryx",
        "Fowlea",
        "Gerarda",
        "Gerrhopilus",
        "Grypotyphlops",
        "Hebius",
        "Hydrophis",
        "Hypnale",
        "Indotyphlops",
        "Liopeltis",
        "Lycodon",
        "Melanophidium",
        "Naja",
        "Oligodon",
        "Ophiophagus",
        "Platyceps",
        "Platyplectrurus",
        "Plectrurus",
        "Proahaetulla",
        "Ptyas",
        "Python",
        "Rhabdophis",
        "Rhabdops",
        "Rhinophis",
        "Sibynophis",
        "Teretrurus",
        "Trimeresurus (Craspedocephalus)",
        "Uropeltis",
        "Xylophis",
      ],
      occurenceitems: ["Common", "Uncommon", "Rare"],
      WLPAitems: [
        { value: "Schedule  -I", text: "Schedule  -I" },
        { value: "Schedule  -II", text: "Schedule  -II" },
        { value: "Schedule  -III", text: "Schedule  -III" },
        { value: "Schedule  -IV", text: "Schedule  -IV" },
        { value: "Not Listed", text: "Not Listed" },
        { value: "Vulnerable (VU)", text: "Vulnerable (VU)" },
        { value: "Near Threatened (NT)", text: "Near Threatened (NT)" },
        {
          value: "Conservation Dependent (CD)",
          text: "Conservation Dependent (CD)",
        },
        { value: "Extinct (EX)", text: "Extinct (EX)" },
        { value: "Extinct in the Wild (EW)", text: "Extinct in the Wild (EW)" },
      ],
      IUCNitems: [
        { value: "Not Evaluated (NE)", text: "Not Evaluated (NE)" },
        { value: "Data Deficient (DD)", text: "Data Deficient (DD)" },
        { value: "Least Concern (LC)", text: "Least Concern (LC)" },
        {
          value: "Critically Endangered (CR)",
          text: "Critically Endangered (CR)",
        },
        { value: "Endangered (EN)", text: "Endangered (EN)" },
        { value: "Vulnerable (VU)", text: "Vulnerable (VU)" },
        { value: "Near Threatened (NT)", text: "Near Threatened (NT)" },
        {
          value: "Conservation Dependent (CD)",
          text: "Conservation Dependent (CD)",
        },
        { value: "Extinct (EX)", text: "Extinct (EX)" },
        { value: "Extinct in the Wild (EW)", text: "Extinct in the Wild (EW)" },
      ],
      statelist: [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar",
        "Chandigarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Lakshadweep",
        "Delhi",
        "Puducherry",
      ],
      panCard: "",
      caption: "",
      author: "",
      // headers: [
      //   { text: "Name", value: "name", width: "100px" },
      //   { text: "Scientific Name", value: "scientificName", width: "100px" },
      //   { text: "Family", value: "family", width: "100px" },
   
      
     
      //   { text: "Actions", value: "_id", width: "20px" }, 
      // ],
    };
  },
  beforeMount() {
    this.getData();
  },
  computed: {
    mainRole() {
      return this.$store.state.userRole;
    },
    computedHeaders() {
      const baseHeaders = [
        { text: 'Name', value: 'name', width: '100px' },
        { text: 'Scientific Name', value: 'scientificName', width: '100px' },
        { text: 'Family', value: 'family', width: '100px' },
      ];

      if (this.mainRole === 'admin') {
        baseHeaders.push({ text: 'Actions', value: '_id', width: '20px' });
      }

      return baseHeaders;
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
    count() {
      this.getData();
    },
    keyword() {
      this.getData();
      this.currentPage=1
    },
  },
  methods: {

    openAddDialog() {
      this.clearForm();
      this.addSnakeDialog = true;
      if(this.expertlist.length === 0) {
        this.getExperts();
      }
    },
    panCardUpload(event) {
      this.panCard = event.target.files[0];
    },
    clearForm() {
      this.commonname = "";
      this.scientificname = "";
      this.state = "";
      this.reginonalname = "";
      this.distribution = "";
      this.scalation = "";
      this.description = "";
      this.venomtype = "";
      this.family = "";
      this.occurence = "";
      this.wlpa = "";
      this.iucn = "";
      this.shortdescription = "";
      this.othername = "";
      this.genus = "";
      this.experts = "";
      this.panCard = "";
      this.caption = "";
      this.author = "";
    },
    getExperts() {
      axios({
        method: "GET",
        url: "/user/experts",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.expertlist = response.data.data;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          (this.ServerError = true), console.log(err);
        });
    },
    handlesubmit() {
      if (!this.commonname) {
        this.msg = "Please Provide Name.";
        this.showSnackBar = true;
        return;
      }
      if (!this.scientificname) {
        this.msg = "Please Provide scientific name.";
        this.showSnackBar = true;
        return;
      }
      
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/snake/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.commonname,
          scientificName: this.scientificname,
          states: this.state,
          rname: this.reginonalname,
          distribution: this.distribution,
          characteristics: this.scalation,
          description: this.description,
          venomType: this.venomtype,
          family: this.family,
          occurence: this.occurence,
          wlpa: this.wlpa,
          iucn: this.iucn,
          shortdes: this.shortdescription,
          othernames: this.othername,
          genus: this.genus,
          experts: this.experts,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              if (this.panCard) {
                const formData = new FormData();
                formData.append("id", response.data.data._id);
                formData.append("photo", this.panCard);
                formData.append("caption", this.caption);
                formData.append("author", this.author);
                axios({
                  method: "POST",
                  url: "/snake/image/",
                  headers: {
                    "x-auth-token": localStorage.getItem("token"),
                    "Content-Type": "multipart/form-data",
                  },
                  data: formData,
                })
                  .then(() => {
                    this.appLoading = false;
                    this.panCard = "";
                    this.caption = "";
                    this.author = "";
                    this.clearForm();
                    this.addSnakeDialog = false;
                    this.getData();
                  })
                  .catch((err) => {
                    this.appLoading = false;
                    console.log(err);
                    this.clearForm();
                    this.addSnakeDialog = false;
                    this.getData();
                  });
              } else {
                this.appLoading = false;
                this.clearForm();
                this.addSnakeDialog = false;
                this.getData();
              }
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    openeditpage(item) {
      this.$router.push({
        path: "/editSnake",
        query: {
          id: item._id,
        },
      });
    },
    openviewpage(item) {
      this.$router.push({
        path: "/snakedetails",
        query: {
          id: item._id,
        },
      });
    },

    opendeleteDialog(item) {
      this.deleteid = item._id;
      this.deleteDialog = true;
    },
    openrejectDialog(item) {
      this.rejectid = item._id;
      this.rejectDialog = true;
    },
    formatDate(date) {
      if (!date) return "-";
      const [year, month, day] = date.slice(0, 10).split("-");
      return `${day}-${month}-${year}`;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/snake/all/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.keyword,
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.items = response.data.data;
              this.Pagelength = response.data.pages;
              this.msg = response.data.msg;
              this.showSnackBar = false;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    deleteoperation() {
      this.appLoading = true;
      axios({
        method: "DELETE",
        url: "/snake/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.deleteid,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Deleted Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.deleteDialog = false;
              this.getData();
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.deleteDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rejectoperation() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/operation/removedeleterequest",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.rejectid,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Rejected Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.rejectDialog = false;
              this.getData();
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.rejectDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
            <style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
</style>